module.exports = __webpack_public_path__ + "static/webflow-89079b098300f459fccd620daa750056.png";